<template>
    <div class="pwa_set">
        <b-overlay :show="is_load">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                    <div class="templ_skin">
                        <div class="pr-3 py-3">
                            <div class="row no-gutters">
                                <div class="col-4 pr-2 text-center" v-for="template in template_skins">
                                    <div :id="template.id" v-bind:class="template.inside_class.add_class"
                                         :class="{is_active:template.is_active}"
                                         class="d-flex bg-white border rounded overflow-hidden text-success js-waves-on waves-effect waves-themed"
                                         style="height: 80px" v-on:click="set_skin(template)" data-placement="top" data-replaceclass="">
                                        <div class="px-2 pt-0 border-right"  v-bind:class="template.inside_class.left_class"></div>

                                        <div class="d-flex flex-column flex-1">
                                            <div class="border-bottom py-1" v-bind:class="template.inside_class.level1"></div>
                                            <div class="flex-1 pt-3 pb-3 px-2" v-bind:class="template.inside_class.level2" ></div>
                                        </div>
                                    </div>
                                    {{template.name}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row no-gutters mt-3">
                        <div class="col-4 px-1 text-center">
                            <div class="color_choise">
                                <div class="title bold fs-xl mb-2">
                                    {{__t('BG_PRIMARY')}}
                                </div>

                                <compact-picker :disable-fields="false" type="hex"
                                                :disable-alpha=true v-model="primary_color" />
                            </div>
                        </div>

                        <div class="col-4 px-1 text-center">
                            <div class="color_choise">
                                <div class="title bold fs-xl mb-2">
                                    {{__t('BG_SEC')}}
                                </div>

                                <compact-picker :disable-fields="false" type="hex"
                                                :disable-alpha=true v-model="secondary_color" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>

        <div class="form-group">
            <div class="next_step text-right">
                <!--
                <button class="btn  btn-success  btn-lg  mt-3 mb-3 imc_succ ml-5" v-on:click.prevent="save">
                    <span class="fal fal fa-check mr-1"></span>
                    {{ __t('SAVE') }}
                </button>
                -->


                <button class="btn  btn-warning  btn-lg  mt-3 mb-3 imc_succ ml-5" v-on:click.prevent="reset">
                    <span class="fal fal fa-check mr-1"></span>
                    {{ __t('RESET') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
//import slider from 'vue-color/src/components/Chrome.vue'
import { Chrome } from 'vue-color'
export default {
    name: "pwa_color",
    components: {
        'compact-picker': Chrome,
    },

    props : {
        pwa : {
            type:Object
        }
    },

    data() {
        return {
            is_load : false,
            template_skins : [
                {
                    name : "White",
                    type : "light",
                    id : "skin-light",
                    inside_class : {
                        add_class : {
                            "border" : true
                        },
                        left_class : {
                            "bg-white" : true,
                        },
                        level1 : {
                            "bg-white" : true,
                            //  "border-primary" : true,
                        },
                        level2 : {
                            "bg-white" : true,
                        }
                    },

                    is_active : false,
                },
                {
                    name : "Dark",
                    type : "dark",
                    id : "skin-dark",
                    inside_class : {
                        add_class : {
                            "border-dark": true,
                        },
                        left_class : {
                            "bg-fusion-500" : true,
                        },
                        level1 : {
                            "bg-fusion-600" : true,
                        },
                        level2 : {
                            "bg-fusion-300" : true
                        }
                    },

                    is_active : false,
                },
            ],

        }
    },
    created() {
        //this.get_pwa_settings();
        EventBus.$on('pwa_settings_loaded',this.get_pwa_settings);
    },

    methods : {

        reset() {
            this.is_load = true;
            api.delete('/internal/user/pwa_settings').then(({data}) => {
                this.is_load = false;
                this.get_pwa_settings();
            })	.catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: this.__t("POSTER_GET_VER")
                })
            });
        },

        set_skin(template)  {
            this.template_skins.map(item => {
                item.is_active = false;
            });
            template.is_active = true;
            this.colors.color_scheme = template.type;
        },

        async get_pwa_settings() {
            this.template_skins.map(item => {
                 if(this.colors.color_scheme == item.type) {
                     this.set_skin(item);
                 }
            });
        }
    },
    computed : {

        primary_color :  {
            get() {
                return this.colors.primary_color;
            },
            set(color) {
                if(color instanceof String || typeof color === 'string') {
                    this.colors.primary_color = color;
                }
                else {
                    if(color.hasOwnProperty("hex")) {
                        this.colors.primary_color = color.hex;
                    }
                }
            }
        },
        secondary_color : {
            get() {
                return this.colors.secondary_color;
            },
            set(secondary_color) {
                if(secondary_color instanceof String || typeof secondary_color === 'string') {
                    this.colors.secondary_color = secondary_color;
                }
                else {
                    if(secondary_color.hasOwnProperty("hex")) {
                        this.colors.secondary_color = secondary_color.hex;
                    }
                }
            }
        },


        colors : {
            get() {
                if (this.pwa.hasOwnProperty("colors")) {
                    return this.pwa.colors;
                }

                return {
                    primary_color: "#194d33",
                    secondary_color: "#ff7f23",
                    color_scheme: "light",
                }
            },
            set(val)  {
                this.pwa.colors = val;
            }
        },

        to_save() {
            let res = {
                'color_scheme' : this.colors.color_scheme,
                "primary_color" : "",
                'secondary_color' : "",
            };

            let primary_color = this.colors.primary_color;
            if(primary_color instanceof String || typeof primary_color === 'string') {
                res.primary_color = primary_color;
            }
            else {
                if(primary_color.hasOwnProperty("hex")) {
                    res.primary_color = primary_color.hex;
                }
            }

            let secondary_color = this.colors.secondary_color;
            if(secondary_color instanceof String || typeof secondary_color === 'string') {
                res.secondary_color = secondary_color;
            }
            else {
                if(secondary_color.hasOwnProperty("hex")) {
                    res.secondary_color = secondary_color.hex;
                }
            }

            return res;
        },
    }
}
</script>

<style scoped>

</style>
